
export function normalizeUrl(url){
    if(url&&url.charAt(url.length-1)!=='/'){
        return url+'/';
    }else{
        return url;
    }
}